import { useEffect, useRef, useState } from "react";

const useAutoPopulateAboutTutor = (tutorId, tutorsData, modelAboutTutor) => {
  const [aboutTutor, setAboutTutor] = useState(modelAboutTutor || "");
  const needUpdateAboutTutor = useRef(false);

  useEffect(() => {
    if (tutorId && tutorsData?.length > 0) {
      if (modelAboutTutor && !needUpdateAboutTutor.current) {
        // First time loading with existing model data - don't override
        needUpdateAboutTutor.current = true;
        return;
      } else {
        // Tutor selection changed - update with new tutor's about
        const selectedTutor = tutorsData.find(tutor => tutor.id === tutorId);
        if (selectedTutor?.about) {
          setAboutTutor(selectedTutor.about);
        }
      }
    }
  }, [tutorId, tutorsData, modelAboutTutor]);

  return aboutTutor;
};

export default useAutoPopulateAboutTutor;
